import { render, staticRenderFns } from "./IconCoop.vue?vue&type=template&id=9b6d93d2&"
import script from "./IconCoop.vue?vue&type=script&lang=ts&"
export * from "./IconCoop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports